import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
  blogId: any;
  blogDetails: any;
  constructor(private _api: ApiService,
    private _route: ActivatedRoute
    ) { }

  ngOnInit() {
    this.blogId = (this._route.snapshot.paramMap.get('id') === null) ? '' : this._route.snapshot.paramMap.get('id');
    this.getBlogDetails();
  }

  getBlogDetails() {
    this._api.getBlogDetails(this.blogId).subscribe(res => {
      this.blogDetails = res;
    }, err => {
      console.log(err);
    });
  }

}
